<template>
  <div class="d-flex flex-row justify-content-between bg-dark text-white-50 px-4 py-2 " v-if="hasAnyLogins()">
    <div class="d-flex flex-row align-items-center">
      <v-icon
          color="#ffffff"
      >
        mdi-account
      </v-icon>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn  color="secondary" dark text v-on="on" v-bind="attrs">

            <span style="font-size: 0.6rem"> {{ $t('BUTTONS.RollBack.CurrentUser') + " ‌" }} </span>
             :
            {{user.name}}
          </v-btn>
        </template>

        <v-list>
          <v-list-item>
            <v-btn
              color="primary"
              text
              class="w-100"
              @click="goToPreUser()"
            >
              {{ $t('BUTTONS.RollBack.back') }}
            </v-btn>
          </v-list-item>

          <v-list-item>
            <v-btn
                class="w-100"
                color="primary"
                text
                @click="goToMainUser()"
            >
              {{ $t('BUTTONS.RollBack.goToMainUser') }}
            </v-btn>
          </v-list-item>
        </v-list>

      </v-menu>


    </div>

    <div class="d-flex flex-row-reverse">
      <v-icon
        color="#ffffff"
      >
        mdi-login
      </v-icon>

      <v-btn
          v-for="(index, l) in logins"
          text
          dark
          color="primary"
          @click="relogin(l)"
      >
        < {{index.name}}
      </v-btn>

      <v-btn
          text
          dark
          disabled
          color="primary"
          @click="relogin(l)"
      >
        {{user.name}}
      </v-btn>
    </div>

  </div>
</template>

<script>
import loginRollback from "@/Utilities/LoginRollback";
export default {
  name: "LoginRollBack",
  data(){
    return {
      logins : []
    }
  },

  mounted() {
    this.logins = loginRollback.getLogins();
  },
  methods:{
    hasAnyLogins(){
      return !!loginRollback.getLogins().length;
    },
    relogin(l){
      loginRollback.changeLogin(l)
      window.location.reload();
    },
    goToPreUser(){
      this.relogin(loginRollback.getLogins().length - 1)
    },
    goToMainUser(){
      this.relogin(0);
    }
  }
}
</script>

<style scoped>

</style>